import React from 'react';
import { Box } from '@abyss/web/ui/Box';
import { Outlet } from 'react-router';
import { Brandmark } from '@abyss/web/ui/Brandmark';
import { GlobalStyles } from '../styles';

export const SharedLayout = () => {
  GlobalStyles();
  return (
    <Box color="$gray2" padding={25} align="start" height="100%" width="100%">
      <Brandmark
        brand="optum"
        size="$sm"
        affiliate="optum"
        variant="lockup"
        color="orange"
      />
      <Box
        color="$gray2"
        padding={40}
        align="center"
        height="100%"
        width="100%"
      >
        <Outlet />
      </Box>
    </Box>
  );
};
